const modelId = value => {
  if (typeof value === 'string') return value
  if (!value || typeof value !== 'object') return null
  if (typeof value.model === 'string') return value.model
  if (typeof value.id === 'string') return value.id
  return null
}

const normalizeModelIds = values => {
  const result = []
  const seen = new Set()
  for (const value of Array.isArray(values) ? values : []) {
    const id = modelId(value)
    if (!id || seen.has(id)) continue
    seen.add(id)
    result.push(id)
  }
  return result
}

module.exports = { modelId, normalizeModelIds }
